import ApiCaller from "api/apiCaller";
import CustomTextInput from "components/CustomTextInput";
import React from "react";
import { Row, Col } from "reactstrap";
import { Icon } from "shared";
import t from "utils/Lang";
import numeral from "numeral";
import CustomDropdownInput from "components/CustomDropdownInput";
import CustomFileInput from "components/CustomFileInput";

type PaymentTermProps = {
  paymentTerms: Array<any>;
  isViewContract: boolean;
  contractId?: number;
  setPaymentTerms: (terms: Array<any>) => void;
  errorData: any;
  fieldIsInvalid: (err: any) => boolean;
  updatePaymentTerm: (index: number) => (attribute: string, value: any) => void;
  taxData: any;
  paymentCalculationTypes: Array<any>;
};

const PaymentTerm = ({
  paymentTerms,
  isViewContract,
  contractId,
  setPaymentTerms,
  errorData,
  fieldIsInvalid,
  updatePaymentTerm,
  taxData,
  paymentCalculationTypes,
}: PaymentTermProps) => {
  return (
    <>
      <h4 className="site-summary__label-title">
        {t().site_contract_modal__payment_term}
      </h4>
      {paymentTerms.map((el, index) => {
        const isAbsolute = el.contract_payment_calculation_type_id
          ? paymentCalculationTypes.find(
              (item) => item.id === el.contract_payment_calculation_type_id
            )?.code !== "store_revenue"
          : false;
        const byRevenue = el.contract_payment_calculation_type_id
          ? paymentCalculationTypes.find(
              (item) => item.id === el.contract_payment_calculation_type_id
            )?.code !== "fixed_rental_fee"
          : false;
        return (
          <Row
            key={`payment-term-${index}`}
            className="site-information-tab__section"
            style={{ position: "relative" }}
          >
            {index > 0 && !isViewContract && (
              <div
                style={{ position: "absolute", right: 2, top: 2, zIndex: 2 }}
                className="normal-button"
              >
                <Icon
                  name="close"
                  size="medium"
                  onClick={() => {
                    const newPaymentTerms = [...paymentTerms];
                    if (el.id && contractId) {
                      ApiCaller.delete(
                        `contract/${contractId}/payment_term/${el.id}`
                      );
                    }
                    newPaymentTerms.splice(index, 1);
                    setPaymentTerms(newPaymentTerms);
                  }}
                />
              </div>
            )}
            <Col sm={{ size: 6, offset: 0 }}>
              <CustomTextInput
                type="date"
                callback={updatePaymentTerm(index)}
                data={el}
                labelText={`${t().from_date} *`}
                attributeName="from_date"
                disabled={isViewContract}
              />
            </Col>
            <Col sm={{ size: 6, offset: 0 }}>
              <CustomTextInput
                type="date"
                callback={updatePaymentTerm(index)}
                data={el}
                labelText={`${t().to_date} *`}
                attributeName="to_date"
                disabled={isViewContract}
              />
            </Col>
            <Col sm={{ size: 6, offset: 0 }}>
              <CustomDropdownInput
                callback={updatePaymentTerm(index)}
                data={el}
                options={paymentCalculationTypes?.map((item) => ({
                  label: item.name,
                  value: item.id,
                }))}
                labelText={`${
                  t().site_contract_modal__type_of_rent_calculation
                } *`}
                attributeName="contract_payment_calculation_type_id"
                invalid={
                  index === 0 &&
                  fieldIsInvalid(
                    errorData?.contract_payment_calculation_type_id
                  )
                }
                formFeedbackText={
                  errorData?.contract_payment_calculation_type_id
                }
                disabled={isViewContract}
              />
            </Col>
            {isAbsolute && (
              <Col sm={{ size: 6, offset: 0 }}>
                <CustomTextInput
                  type="text"
                  callback={updatePaymentTerm(index)}
                  data={el}
                  labelText={`${t().rental_fee} (VND) *`}
                  attributeName="rental_fee"
                  isNumeric
                  invalid={index === 0 && fieldIsInvalid(errorData?.rental_fee)}
                  formFeedbackText={errorData?.rental_fee}
                  disabled={isViewContract}
                />
              </Col>
            )}
            {isAbsolute && index > 0 && (
              <Col sm={{ size: 6, offset: 0 }}>
                <CustomTextInput
                  type="text"
                  callback={updatePaymentTerm(index)}
                  data={el}
                  labelText={`${t().increase_fee_rate} * (%)`}
                  attributeName="increase_fee_rate"
                  isNumeric
                  isDecimal
                  disabled={isViewContract}
                />
              </Col>
            )}
            {isAbsolute && (
              <Col sm={{ size: 6, offset: 0 }}>
                <CustomTextInput
                  type="text"
                  callback={updatePaymentTerm(index)}
                  value={numeral(
                    Math.round(
                      (el?.rental_fee || 0) *
                        ((taxData.tax_percentage || 0) / 100 + 1)
                    )
                  ).format("0,0")}
                  labelText={t().rental_fee_with_tax}
                  attributeName="increase_fee_rate_with_tax"
                  isNumeric
                  isDecimal
                />
              </Col>
            )}
            {byRevenue && (
              <Col sm={{ size: 6, offset: 0 }}>
                <CustomTextInput
                  type="text"
                  callback={updatePaymentTerm(index)}
                  disabled={isViewContract}
                  labelText={t().rental_fee_percent}
                  attributeName="revenue_share_percentage"
                  isNumeric
                  isDecimal
                  data={el}
                  invalid={
                    index === 0 &&
                    fieldIsInvalid(errorData?.revenue_share_percentage)
                  }
                  formFeedbackText={errorData?.revenue_share_percentage}
                />
              </Col>
            )}
            <Col sm={{ size: 6, offset: 0 }}>
              <CustomFileInput
                callback={updatePaymentTerm(index)}
                data={el}
                labelText={t().contract_file_payment}
                attribute="payment_file"
              />
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default PaymentTerm;
